module.exports = __webpack_public_path__ + "img/marker-on-the-way-to-service-point.611f885e.svg";